// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__SQc3W","header":"ReportDetails_header__8MwBN","title":"ReportDetails_title__2Hlpp","left":"ReportDetails_left__2mMtH"};